export default {
    driverStatusLogDelete_title: "Eliminar tarjetas de tiempo",
    driverStatusLogDelete_success: "Exito",
    driverStatusLogDelete_successMessage: "Tarjetas de tiempo eliminadas",
    driverStatusLogDelete_deleteWarning: "¿Está seguro de que desea eliminar las siguientes tarjetas de tiempo de conductor? Esta acción no se puede deshacer"
};